import React from 'react'
import { Helmet } from 'react-helmet';
import withNavElements from '../components/withNavElements';
import HomePageContent from './Home/HomePageContent';

const Home = () => {

    return (
        <>
            <Helmet>
                <title>Skyshops</title>
            </Helmet>
            <HomePageContent />
        </>
    )
}

export default withNavElements(Home);
